import { Helmet } from 'react-helmet-async'

import Button from '../ui/Button'
import Container from '../ui/Container'

export const NotFound = () => {
  return (
    <>
      <Helmet>
        <title>Page Not Found | Meditex Healthcare Hub Limited</title>
      </Helmet>
      <Container className="py-24 flex flex-col items-center text-center gap-4">
        <span className="text-6xl font-extrabold text-primary-200">404</span>
        <h1 className="text-2xl font-bold text-primary">You've landed on a page that doesn't exist</h1>
        <p className="text-gray-600 max-w-md">
          The page you're looking for may have been moved or no longer exists.
        </p>
        <Button to="/" variant="primary" className="mt-2">Back to Home</Button>
      </Container>
    </>
  );
}
